import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import { Alert, CircularProgress, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import useApiHook from "../../hooks/useApiHook";
import PatientListBase from "./PatientListBase";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePatientRefresh } from "../../store/modal-context";

const PatientList = ({
    isActive = true,
    selectionMode = 'single',
    selectedPatientId = null,
    selectedPatientIds = null,
    onSelect = () => { },
    getPatientLink = null,
}) => {
    const { response, makeRequest, loading, error } = useApiHook();
    const location = useLocation();
    const { patientsVersion } = usePatientRefresh();

    useEffect(() => {
        if (!isActive) {
            return;
        }

        makeRequest('/folder/getAll');
    }, [patientsVersion, isActive, location.pathname, makeRequest]);

    const items = useMemo(() => {
        if (!response?.data || !Array.isArray(response.data)) {
            return [];
        }

        return response.data.map((patient) => ({
            id: patient.id,
            title: patient.name,
            icon: <FolderSharedOutlinedIcon />
        }));
    }, [response]);

    if (loading && isActive) {
        return (
            <Stack alignItems="center" py={4}>
                <CircularProgress />
            </Stack>
        );
    }

    if (error && isActive) {
        return (
            <Alert severity="error">
                Impossibile caricare i pazienti.
            </Alert>
        );
    }

    if (isActive && items.length === 0) {
        return (
            <Stack alignItems="center" py={3}>
                <Typography variant="body2" sx={{ opacity: 0.65 }}>
                    Nessun paziente.
                </Typography>
            </Stack>
        );
    }

    return (
        <PatientListBase
            items={items}
            selectedItemId={selectionMode === 'single' ? selectedPatientId : null}
            selectedItemIds={selectionMode === 'multiple' && Array.isArray(selectedPatientIds) ? selectedPatientIds : []}
            onItemClick={onSelect}
            getItemLink={getPatientLink}
        />
    );
};

export default PatientList;
